// extracted by mini-css-extract-plugin
module.exports = {"title":"OptionSnippets_title__1n8l1","container":"OptionSnippets_container__1qShJ","sections":"OptionSnippets_sections__3YVqL"};